import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { DocumentService } from 'src/app/_services/document.services';

@Component({
  selector: 'app-redact-keywords',
  templateUrl: './redact-keywords.component.html',
  styleUrls: ['./redact-keywords.component.scss']
})
export class RedactKeywordsComponent implements OnInit {
  @Input() documentId: string;
  @Output() openRedactDocumentTab = new EventEmitter<boolean>()
  @Output() close = new EventEmitter<boolean>()
  keywordsForm: FormGroup
  successMessage: boolean = false


  constructor(
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    this.newFormHandler()
  }

  newFormHandler() {
    this.keywordsForm = new FormGroup({
      keywords: new FormArray([this.initKeyword()])
    })
  }

  initKeyword() {
    return new FormGroup({
      keyword: new FormControl('', Validators.required)
    })
  }

  addNewKeyword() {
    const control = <FormArray>this.keywordsForm.get('keywords');
    control.push(this.initKeyword());
  }

  getKeyword(form) {
    return form.controls.keywords.controls;
  }

  deleteKeyword(index: number) {
    this.keywordsArray.removeAt(index);
  }

  get keywordsArray() {
    return <FormArray>this.keywordsForm.get("keywords")
  }

  redactDocumentHandler() {
    const payload = {
      docId: this.documentId,
      keywords: []
    }
    this.keywordsForm.value['keywords'].forEach(element => {
      payload.keywords.push(element.keyword)
    });
    this.documentService.redactKeywordsOnDocument(payload).subscribe(resp => {
      this.successMessage = true
    })
  }

  onClose() {
    this.openRedactDocumentTab.emit(false)
    this.successMessage = false
  }

  onCancel() {
    this.close.emit(true)
  }

}
